import React from 'react';
import styles from './InspectionCard.module.scss';
import { Text } from '../../typography';
import { getLocalTime } from '../../../utilities/time';
import MultiAvatar from '../../MultiAvatar';
import { useCurrentUser } from '../../../providers/UserProvider';
import TextWithIcon from '../../typography/TextWithIcon';
import { customColors } from '../../../utilities';
import { useTranslation } from 'react-i18next';
import { keys } from '../../../utilities/translator/translation_keys';
import Label from '../../action_items/Label';
import classNames from 'classnames';

export default function InspectionCard({ inspection, onClick, className }) {
  const { assessmentTypes } = useCurrentUser();
  const {
    vehicle,
    template: { templateType, title },
  } = inspection;
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.container, className)} onClick={onClick}>
      <div className={styles.topContainer}>
        <div className={styles.horizontalSplit}>
          <div className={styles.leftContainer}>
            <TextWithIcon
              leftIcon={
                templateType === 'VEHICLE'
                  ? assessmentTypes['fleet'].icon
                  : assessmentTypes[templateType?.toLowerCase()]?.icon
              }
              iconProps={{
                color:
                  templateType === 'VEHICLE'
                    ? customColors.YELLOW
                    : assessmentTypes[templateType?.toLowerCase()]?.color,
              }}
              noSelect
              size="md"
              weight="semiBold"
              noMargin
              truncate
            >
              {title}
            </TextWithIcon>
          </div>
          <MultiAvatar
            className={styles.avatars}
            users={inspection.participants}
          />
        </div>
      </div>
      <div className={styles.bottomContainer}>
        <div className={styles.horizontalSplit}>
          <div className={styles.flexRow}>
            <div>
              <Label
                name={
                  !!inspection.isDraft
                    ? t(keys.common.IN_PROGRESS)
                    : t(keys.common.COMPLETE)
                }
                color={!!inspection.isDraft ? 'yellow' : 'green'}
              />
            </div>
            <Text
              noSelect
              size="sm"
              weight="semiBold"
              color="secondary"
              truncate
              noMargin
            >
              {vehicle?.unitNumber || inspection?.subject || ''}
            </Text>
          </div>
          <Text
            noSelect
            size="sm"
            color="secondary"
            noMargin
            weight="semiBold"
          >{`Created ${getLocalTime(inspection.dateCreated).fromNow()}`}</Text>
        </div>
      </div>
    </div>
  );
}
